import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import block01 from "./components/block-01";
import block02 from "./components/block-02";

const principle: Slide = {
  title: "",
  description:
    "Recordings of the lombard speech are made available here. Listen to change in pitch of the voice. For the recording with Lombard speech you can listen to the recordings with the noise mixed in or not. ",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 3,
      rows: 4,
      rowsSize: [2, 4, 1, 1],
      components: [[], block01, block02, []],
    },
  },
};

export default principle;
